import {isMobile} from "../../js/global-scripts";

const canvas = document.querySelector('.m-about__bg')
if (canvas && !isMobile.any()) {
    const ctx = canvas.getContext('2d')
    const img = new Image();
    const section = canvas.closest('.m-about')
    const DPR = Math.min(window.devicePixelRatio, 1)//2
    let W = section.clientWidth * DPR
    let H = section.clientHeight * DPR

    canvas.width = W
    canvas.height = H
    canvas.style.width = section.clientWidth + 'px'
    canvas.style.height = section.clientHeight + 'px'

    window.addEventListener('resize', e => {
        W = section.clientWidth * DPR
        H = section.clientHeight * DPR
        canvas.width = W
        canvas.height = H
        canvas.style.width = section.clientWidth + 'px'
        canvas.style.height = section.clientHeight + 'px'

        draw()
    })

    const RADIUS = 113*DPR//226
    const settings = {
        play: false,
        count: 16,
        mouse: {x: 0, y: 0},
        radius: 0,
        pattern: null
    }

    img.src = 'img/grass-256.jpg'
    img.onload = () => {
        settings.pattern = ctx.createPattern(img, 'repeat')
        draw()
    }

    section.addEventListener('mouseenter', e => {
        settings.radius = RADIUS
        settings.play = true
        animate()
    })
    section.addEventListener('mouseleave', e => {
        settings.mouse.x = 0
        settings.mouse.y = 0
        settings.radius = 0
        settings.play = false
        draw()
    })
    section.addEventListener('mousemove', e => {
        const center = getCenter(e);
        settings.mouse.x = center.x
        settings.mouse.y = center.y
    })

    function getCenter(e) {
        const rect = section.getBoundingClientRect()
        const cx = e.clientX - rect.left
        const cy = e.clientY - rect.top
        return {x: cx * DPR, y: cy * DPR}
    }

    function draw() {
        ctx.clearRect(0, 0, W, H)

        ctx.save()
        ctx.beginPath()
        for (let i = 0; i < settings.count; i++) {
            const c = Math.PI * 2
            const startAngle = i / settings.count * c
            const endAngle = (i + 1) / settings.count * c

            ctx.arc(settings.mouse.x, settings.mouse.y, settings.radius, startAngle, endAngle, false)
        }
        ctx.closePath()
        ctx.clip()

        if (settings.pattern) {
            ctx.fillStyle = settings.pattern
            ctx.fillRect(0, 0, W, H)
            ctx.fillStyle = 'rgba(185,183,139, .6)'
            ctx.fillRect(0, 0, W, H)
        }
        ctx.restore()
    }

    function animate(time = 0) {
        if (!settings.play) return

        settings.radius = RADIUS + Math.sin(time*.0002) * 30

        draw()

        window.requestAnimationFrame(animate)
    }
}